import { paymentServiceVersion } from '../configuration';

export const adyenRestaurantConfigurationPath = `${paymentServiceVersion}/adyen/configurations/restaurants/`;
export const adyenBrandConfigurationPath = `${paymentServiceVersion}/adyen/configurations/brands/`;
export const adyenSubmitPaymentPath = `${paymentServiceVersion}/adyen/payments`;
export const adyenResumePaymentPath = `${paymentServiceVersion}/adyen/payments/resume`;
